export default [
  {
    value: '01',
    text: 'Январь',
  },
  {
    value: '02',
    text: 'Февраль',
  },
  {
    value: '03',
    text: 'Март',
  },
  {
    value: '04',
    text: 'Апрель',
  },
  {
    value: '05',
    text: 'Май',
  },
  {
    value: '06',
    text: 'Июнь',
  },
  {
    value: '07',
    text: 'Июль',
  },
  {
    value: '08',
    text: 'Август',
  },
  {
    value: '09',
    text: 'Сентябрь',
  },
  {
    value: '10',
    text: 'Октябрь',
  },
  {
    value: '11',
    text: 'Ноябрь',
  },
  {
    value: '12',
    text: 'Декабрь',
  },
]
